import axios from "axios";
import userService from "src/utils/UserService";
const cotAxios = axios.create({
    withCredentials: true
});
// 添加响应拦截器
cotAxios.interceptors.response.use(
    (response) => response,
    (error) => {
        // console.log("error");
        // if (ignoreApis.includes(error.config.url)) {
        //     return Promise.reject(error);
        // }
        if (error.response?.status === 401) {
            userService.clear();
            if (window.location.pathname !== "/login") {
                window.location.href = `/login?redirect_uri=${
                    encodeURIComponent(`${window.location.pathname}${window.location.search}`)
                }`;
            }
        }

        return Promise.reject(error);
    }
);
export default cotAxios;
